if (!customElements.get('quick-cart-drawer')) {
  class QuickCartDrawer extends HTMLElement {
    constructor() {
      super();
      if (Shopify.designMode) {
        window.addEventListener('shopify:section:load', this.init.bind(this));
        this.parentElement.addEventListener('shopify:section:select', () => this.open());
        this.parentElement.addEventListener('shopify:section:deselect', () => this.close());
      }
    }

    connectedCallback() {
      this.init();
    }

    init() {
      this.toggleState = false;

      if (!this.classList.contains('is--open')) {
        document.querySelector('body').classList.remove('overflow-hidden');
      }

      this.querySelector('.button--close').addEventListener('click', this.close.bind(this));
      this.querySelector('.quick-cart-drawer__backdrop').addEventListener('click', this.close.bind(this));

      this.querySelector('.quick-cart-drawer__blocks').addEventListener('keydown', e => {
        if (e.key === 'Escape' && this.toggleState) {
          this.close();
        }

        if (this.toggleState) {
          const focusableElements = this.querySelectorAll(
            'button, [href], input, select, label, textarea, [tabindex]:not([tabindex="-1"])'
          );
          const firstFocusableElement = focusableElements[0];
          const lastFocusableElement = focusableElements[focusableElements.length - 1];

          let isTabPressed = e.key === 'Tab';

          if (!isTabPressed) {
            return;
          }

          if (e.shiftKey) {
            if (document.activeElement === firstFocusableElement) {
              e.preventDefault();
              lastFocusableElement.focus();
            }
          } else {
            if (document.activeElement === lastFocusableElement) {
              e.preventDefault();
              firstFocusableElement.focus();
            }
          }
        }
      });

      this.initTriggers();
      if (!this.sheviCarouselClick) {
        this.sheviCarouselClick = event => {
          if (!window.matchMedia('(max-width:749px)').matches || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          const card = event.target.closest('#shopify-section-template--28465821745186__shoppable_carousel_WYLGiA a.shoppable-card[href]');
          if (!card) return;
          event.preventDefault();
          event.stopPropagation();
          this.openThemeProduct(card.href, card);
        };
        document.addEventListener('click', this.sheviCarouselClick);
      }
    }

    initTriggers() {
      const observer = new MutationObserver(() => {
        document.querySelectorAll('.quick-cart-drawer__trigger').forEach(element => {
          if (!element._init) {
            // Daha önce eklenmiş mi kontrol edin
            element.addEventListener('click', event => {
              this.fetchProductForQuickCartDrawer(event);
            });
            element._init = true; // Eklenmiş olarak işaretleyin
          }
        });
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }

    async fetchProductForQuickCartDrawer(event) {
      const recommendationTrigger = event.target.closest('.quick-cart-drawer__trigger--recommendations');
      if (recommendationTrigger) {
        event.preventDefault();
        event.stopPropagation();
        this.openThemeProduct(recommendationTrigger.dataset.productUrl, recommendationTrigger);
        return;
      }
      const mobileTrigger = event.target.closest('[data-product-url]');
      if (window.matchMedia('(max-width:749px)').matches && mobileTrigger) {
        event.preventDefault();
        event.stopPropagation();
        this.openThemeProduct(mobileTrigger.dataset.productUrl, mobileTrigger);
        return;
      }
      this.classList.remove('shevi-theme-product');
      /** stop autoplay on quick cart trigger */
      if (event.target.closest('card-product-slider')) {
        event.target.closest('card-product-slider').slider.autoplay.stop();
        event.target.closest('card-product-slider').classList.add('product--open-on-quick-cart');
      }

      const isRecommendations = event.target.classList.contains('quick-cart-drawer__trigger--recommendations');

      const productCard = event.target.closest('product-card');
      let productOptions = null;

      if (!isRecommendations) {
        if (!productCard) return;
        // get all checked options
        productOptions = productCard.querySelectorAll('input[type="radio"]:checked, select');
      }

      const trigger = event.target.closest('[data-product-url]');
      trigger.classList.toggle('is--loading');
      try {
        // if root contains locale, add locale to productUrl as prefix
        let fetchPrefix = '';
        if (window.Shopify.routes.root.includes(`/${window.Shopify.locale}/`)) {
          fetchPrefix = `/${window.Shopify.locale}`;
        }

        const productCardResponse = await fetch(`${fetchPrefix}${trigger.dataset.productUrl}/?view=quick-cart`);
        if (!productCardResponse) return;

        const productCardHTML = await productCardResponse.text();
        const productCard = document.createElement('DIV');
        productCard.insertAdjacentHTML('beforeend', productCardHTML);
        if (!productCard.querySelector('.quick-cart-product')) return;
        this.querySelector('.quick-cart-drawer__main').innerHTML = '';
        this.querySelector('.quick-cart-drawer__main').append(productCard.querySelector('.quick-cart-product'));

        this.sliderInstance = new Swiper('.quick-cart-drawer__media-swiper', {
          slidesPerView: 1.25,
          spaceBetween: 8,
          freeMode: {
            enabled: true
          },
          breakpoints: {
            750: {
              slidesPerView: 2
            }
          }
        });
      } catch (error) {
        // console.log(error);
      } finally {
        trigger.classList.toggle('is--loading');

        if (!isRecommendations) {
          // update quick cart drawer options with product options
          productOptions.forEach(productOption => {
            let productOptionName = productOption.name;
            const optionSectionIdAttribute = productOption.dataset?.sectionId;

            if (optionSectionIdAttribute) {
              productOptionName = productOptionName.replace(optionSectionIdAttribute, '');
            }

            const quickCartDrawerOption = this.querySelector(
              `[name="${CSS.escape(productOptionName)}-quick-cart-product"][value="${CSS.escape(productOption.value)}"]`
            );
            const quickCartDrawerOptionLabel = quickCartDrawerOption.parentElement.parentElement.querySelector('legend');

            // before updating radio button state, remove checked attribute for specific name
            this.querySelectorAll(`[name="${productOptionName}"]`).forEach(radioInput => {
              radioInput.removeAttribute('checked');
              radioInput.closest('li').classList.remove('checked');
            });

            if (quickCartDrawerOption) {
              quickCartDrawerOption.setAttribute('checked', '');
              const quickCartDrawerOptionLabelSpan = quickCartDrawerOptionLabel.querySelector('[data-selected-variant]');
              if (quickCartDrawerOptionLabelSpan) {
                quickCartDrawerOptionLabelSpan.innerHTML = productOption.value;
              }
            }

            // update variant id in product card with selected variant id
            this.querySelector('product-card').querySelector('input[name="id"]').value =
              productCard.querySelector('input[name="id"]').value;

            // update radio button state
            if (quickCartDrawerOption) {
              quickCartDrawerOption.closest('li').classList.add('checked');
            }

            // initilise for disabled states to be checked and updated
            this.querySelector('product-card').init();
          });
        }

        // short wait before opening drawer
        setTimeout(() => {
          this.open();
        }, 500);

        // add small delay to open drawer
        // this.open();

        // update label when variant is selected
        this.querySelector('.quick-cart-drawer__main')
          .querySelectorAll('.variant-option-radio-input')
          .forEach(radioInput => {
            radioInput.addEventListener('change', event => {
              const quickCartDrawerOptionLabel = event.target.parentElement.parentElement.querySelector('legend');
              const quickCartDrawerOptionLabelSpan = quickCartDrawerOptionLabel.querySelector('[data-selected-variant]');
              if (quickCartDrawerOptionLabelSpan) {
                quickCartDrawerOptionLabelSpan.innerHTML = event.target.value;
              }

              // update variant id in product card with selected variant id
              const selectedVariantId = this.querySelector(".product-card__add-to-cart--form input[name='id']").value;

              // get product variants data
              const productVariantsData = this.querySelector('product-card').variantsObj;
              const featuredMedia = productVariantsData.find(variant => variant.id == selectedVariantId)?.featured_media;

              if (featuredMedia) {
                this.setActiveMedia(featuredMedia.id);
              }
            });
          });
      }
    }


    async openThemeProduct(url, trigger) {
      const destination = new URL(url, window.location.origin);
      destination.searchParams.delete('view');
      this.classList.add('shevi-theme-product');
      const useSetDesign = window.matchMedia('(max-width:749px)').matches && (trigger ? Boolean(trigger.closest('[id*="__shoppable_carousel_"], .quick-cart-drawer__trigger--recommendations')) : this.classList.contains('shevi-set-design'));
      this.classList.toggle('shevi-set-design', useSetDesign);
      const heading = this.querySelector('.quick-cart-drawer__header h5');
      if (useSetDesign && heading) heading.textContent = 'Product details';
      let expand = this.querySelector('.shevi-product-expand');
      if (!expand) {
        expand = document.createElement('a');
        expand.className = 'shevi-product-expand';
        expand.setAttribute('aria-label', 'Open full product page');
        expand.title = 'Open full product page';
        expand.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 4h6v6M20 4l-7 7M10 20H4v-6M4 20l7-7"/></svg>';
        this.querySelector('.quick-cart-drawer__header').prepend(expand);
        expand.addEventListener('click', () => {
          const frame = this.querySelector('.shevi-theme-product-frame');
          const variant = frame?.contentDocument?.querySelector('form[action*="/cart/add"] [name="id"]')?.value;
          const target = new URL(expand.href);
          if (variant) target.searchParams.set('variant', variant);
          expand.href = target.href;
        });
      }
      expand.href = destination.href;
      this.returnTrigger = trigger || this.returnTrigger;
      const main = this.querySelector('.quick-cart-drawer__main');
      main.replaceChildren();
      const loading = document.createElement('p');
      loading.className = 'shevi-product-loading';
      loading.setAttribute('role', 'status');
      loading.textContent = 'Loading product…';
      const frame = document.createElement('iframe');
      frame.className = 'shevi-theme-product-frame';
      frame.title = 'Product details';
      frame.style.visibility = 'hidden';
      main.append(loading, frame);
      frame.addEventListener('load', () => {
        if (!frame.hasAttribute('srcdoc')) return;
        try {
          const doc = frame.contentDocument;
          if (!doc.querySelector('.main-product')) throw new Error('Product unavailable');
          const style = doc.createElement('style');
          style.textContent = 'html,body{height:auto!important;overflow:auto!important} .shopify-section-group-header-group,body > footer,body > back-to-top,body > country-drawer,body > .shopify-app-block,body > .shopify-section-group-overlay-group{display:none!important} #MainContent{padding-top:0!important;margin-top:0!important} #MainContent > :not(.main-product){display:none!important} .main-product{padding-top:16px!important} .main-product .product-grid{align-items:start!important} .main-product .product-grid__sticky{position:static!important;inset-block-start:auto!important} @media(min-width:750px){.main-product .product-grid{grid-template-columns:minmax(0,1.1fr) minmax(0,1fr)!important;column-gap:32px!important}.main-product .product-grid__item{grid-column:auto!important;min-width:0!important}.main-product .product__title{font-size:30px!important;line-height:1.22!important;letter-spacing:0!important;overflow-wrap:normal!important;word-break:normal!important;margin-bottom:20px!important}}';
          doc.head.append(style);
          if (useSetDesign) {
            const mainContent = doc.querySelector('#MainContent');
            mainContent.classList.add('bys-product-page-drawer__content', 'is-ready');
            const story = mainContent.querySelector('.section-multitile')?.closest('.shopify-section');
            let after = story?.nextElementSibling;
            while (after) { const remove = after; after = after.nextElementSibling; remove.remove(); }
            const mobileStyle = doc.createElement('style');
            mobileStyle.textContent = '#MainContent > .shopify-section:has(.section-multitile){display:block!important} #MainContent > .main-product{padding-top:0!important}';
            doc.head.append(mobileStyle);
            this.initSetDesignGallery(doc);
          }
          doc.addEventListener('keydown', e => { if(e.key === 'Escape') this.close(); });
          doc.addEventListener('click', e => {
            const recommendation = e.target.closest('.quick-cart-drawer__trigger--recommendations[data-product-url]');
            if (recommendation) {
              e.preventDefault();
              e.stopImmediatePropagation();
              this.openThemeProduct(recommendation.dataset.productUrl);
              return;
            }
            const link = e.target.closest('a[href]');
            if (link) {
              const next = new URL(link.href, destination.origin);
              if (next.origin === destination.origin && next.pathname.includes('/products/')) {
                e.preventDefault(); e.stopImmediatePropagation();
                this.openThemeProduct(next.href);
                return;
              }
            }
            const button = e.target.closest('button[name="add"]');
            if (button && button.closest('form[action*="/cart/add"]')) {
              e.preventDefault(); e.stopImmediatePropagation();
              this.addThemeProduct(button.closest('form'), button);
            }
          }, true);
          doc.addEventListener('submit', e => {
            if (!e.target.matches('form[action*="/cart/add"]')) return;
            e.preventDefault(); e.stopImmediatePropagation();
            this.addThemeProduct(e.target, e.target.querySelector('button[name="add"]'));
          }, true);
          loading.remove();
          frame.style.visibility = 'visible';
        } catch (error) {
          loading.textContent = 'Unable to load this product. Please close and try again.';
        }
      });
      this.open();
      try {
        const response = await fetch(destination.href);
        if (!response.ok) throw new Error('Product unavailable');
        const html = await response.text();
        if (!frame.isConnected) return;
        const page = new DOMParser().parseFromString(html, 'text/html');
        const base = page.createElement('base');
        base.href = destination.href;
        page.head.prepend(base);
        if (useSetDesign) {
          page.querySelectorAll('product-info').forEach(info => info.dataset.updateUrl = 'false');
          const sharedStyle = page.createElement('link');
          sharedStyle.rel = 'stylesheet';
          sharedStyle.href = this.dataset.setDesignCss;
          page.head.append(sharedStyle);
          const mainContent = page.querySelector('#MainContent');
          mainContent.classList.add('bys-product-page-drawer__content', 'is-ready');
          mainContent.innerHTML = mainContent.innerHTML.replace(/<swiper-product-gallery\b/g, '<div data-bys-product-gallery').replace(/<\/swiper-product-gallery>/g, '</div>');
        }
        frame.srcdoc = '<!doctype html>' + page.documentElement.outerHTML;
      } catch (error) {
        loading.textContent = 'Unable to load this product. Please use the expand button to view it.';
      }
    }

    initSetDesignGallery(doc) {
      const content = doc.querySelector('#MainContent');
      const drawer = this;
      const document = doc;
      const window = doc.defaultView;
      const getComputedStyle = window.getComputedStyle.bind(window);
    function initDrawerGallery() {
      var gallery = content.querySelector('.shopify-section.main-product .swiper--product-gallery');
      var galleryTrack = gallery ? gallery.querySelector('.swiper-wrapper') : null;
      var slides = galleryTrack ? Array.from(galleryTrack.querySelectorAll(':scope > .swiper-slide[data-media-id]')) : [];
      var thumbsViewport = content.querySelector('.shopify-section.main-product .swiper--product-thumbs');
      var thumbsTrack = thumbsViewport ? thumbsViewport.querySelector('.swiper-wrapper') : null;
      var thumbs = thumbsTrack ? Array.from(thumbsTrack.querySelectorAll(':scope > .swiper-slide[data-media-id]')) : [];

      if (!gallery || !galleryTrack || !slides.length || !thumbsViewport || !thumbs.length) return;

      gallery.classList.add('bys-drawer-gallery');
      thumbsViewport.classList.add('bys-drawer-gallery-thumbs');

      var title = content.querySelector('.shopify-section.main-product h1');
      function alignGallery() {
        if (!title) return;
        var inset = Math.max(0, title.getBoundingClientRect().left - gallery.getBoundingClientRect().left);
        gallery.style.setProperty('padding-left', inset + 'px', 'important');
        gallery.style.setProperty('padding-right', inset + 'px', 'important');
        gallery.style.setProperty('scroll-padding-left', inset + 'px', 'important');
        var thumbContainer = thumbsViewport.closest('.main-product__media--thumbs-wrapper');
        if (thumbContainer) {
          var thumbInset = Math.max(0, title.getBoundingClientRect().left - thumbContainer.getBoundingClientRect().left);
          thumbContainer.style.setProperty('padding-left', thumbInset + 'px', 'important');
          thumbContainer.style.setProperty('padding-right', thumbInset + 'px', 'important');
        }
      }
      function slidePosition(slide) {
        return Math.max(0, slide.offsetLeft - (parseFloat(getComputedStyle(gallery).paddingLeft) || 0));
      }
      alignGallery();
      if (drawer.__bysGalleryResize) drawer.__bysGalleryResize.disconnect();
      if (window.ResizeObserver) {
        drawer.__bysGalleryResize = new ResizeObserver(alignGallery);
        drawer.__bysGalleryResize.observe(gallery);
      }
      var activeIndex = 0;
      var scrollFrame = null;
      var scrollSyncLocked = false;
      var scrollUnlockTimer = null;

      function getLastNavigableIndex() {
        var maximumScroll = Math.max(0, gallery.scrollWidth - gallery.clientWidth);
        var closestIndex = 0;
        var closestDistance = Infinity;

        slides.forEach(function (slide, index) {
          var distance = Math.abs(slidePosition(slide) - maximumScroll);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        return closestIndex;
      }

      function setActive(index, behavior, moveGallery) {
        index = Math.max(0, Math.min(index, slides.length - 1));
        activeIndex = index;

        slides.forEach(function (slide, slideIndex) {
          var isActive = slideIndex === index;
          slide.classList.toggle('is-bys-active', isActive);
          slide.setAttribute('aria-current', isActive ? 'true' : 'false');
        });

        thumbs.forEach(function (thumb, thumbIndex) {
          var isActive = thumbIndex === index;
          thumb.classList.toggle('is-bys-active', isActive);
          thumb.setAttribute('aria-current', isActive ? 'true' : 'false');
        });

        if (moveGallery) {
          scrollSyncLocked = true;
          if (scrollUnlockTimer) window.clearTimeout(scrollUnlockTimer);

          gallery.scrollTo({
            left: Math.max(0, slidePosition(slides[index])),
            behavior: behavior || 'smooth'
          });

          scrollUnlockTimer = window.setTimeout(function () {
            scrollSyncLocked = false;
            scrollUnlockTimer = null;
          }, behavior === 'smooth' ? 650 : 0);
        }

        var activeThumb = thumbs[index];
        if (activeThumb) {
          thumbsViewport.scrollTo({
            left: Math.max(0, activeThumb.offsetLeft - (thumbsViewport.clientWidth - activeThumb.clientWidth) / 2),
            behavior: behavior || 'smooth'
          });
        }

        if (previousButton) {
          previousButton.hidden = index === 0;
          previousButton.setAttribute('aria-disabled', index === 0 ? 'true' : 'false');
        }

        if (nextButton) {
          var isAtEnd = index >= getLastNavigableIndex();
          nextButton.hidden = isAtEnd;
          nextButton.setAttribute('aria-disabled', isAtEnd ? 'true' : 'false');
        }
      }

      thumbs.forEach(function (thumb, index) {
        thumb.setAttribute('role', 'button');
        thumb.setAttribute('tabindex', '0');
        thumb.setAttribute('aria-label', 'View product image ' + (index + 1));

        thumb.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          setActive(index, 'smooth', true);
        });

        thumb.addEventListener('keydown', function (event) {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          setActive(index, 'smooth', true);
        });
      });

      gallery.addEventListener('scroll', function () {
        if (scrollFrame) window.cancelAnimationFrame(scrollFrame);
        scrollFrame = window.requestAnimationFrame(function () {
          if (scrollSyncLocked) return;

          var closestIndex = 0;
          var closestDistance = Infinity;

          slides.forEach(function (slide, index) {
            var distance = Math.abs(slidePosition(slide) - gallery.scrollLeft);
            if (distance < closestDistance) {
              closestDistance = distance;
              closestIndex = index;
            }
          });

          if (closestIndex !== activeIndex) setActive(closestIndex, 'auto', false);
        });
      }, { passive: true });

      var pointerDragging = false;
      var pointerAxis = null;
      var pointerStartX = 0;
      var pointerStartY = 0;
      var pointerStartScroll = 0;
      var pointerStartIndex = 0;
      var suppressGalleryClick = false;

      gallery.addEventListener('dragstart', function (event) {
        event.preventDefault();
      });

      gallery.addEventListener('touchstart', function () {
        if (scrollUnlockTimer) window.clearTimeout(scrollUnlockTimer);
        scrollUnlockTimer = null;
        scrollSyncLocked = false;
      }, { passive: true });

      gallery.addEventListener('pointerdown', function (event) {
        if (window.innerWidth > 749 || event.pointerType !== 'mouse') return;
        if (event.button !== 0) return;

        if (scrollUnlockTimer) window.clearTimeout(scrollUnlockTimer);
        scrollUnlockTimer = null;
        scrollSyncLocked = false;
        pointerDragging = true;
        pointerAxis = null;
        pointerStartX = event.clientX;
        pointerStartY = event.clientY;
        pointerStartScroll = gallery.scrollLeft;
        pointerStartIndex = activeIndex;
      });

      gallery.addEventListener('pointermove', function (event) {
        if (!pointerDragging) return;

        var distanceX = event.clientX - pointerStartX;
        var distanceY = event.clientY - pointerStartY;

        if (!pointerAxis) {
          if (Math.max(Math.abs(distanceX), Math.abs(distanceY)) < 7) return;
          pointerAxis = Math.abs(distanceX) > Math.abs(distanceY) ? 'horizontal' : 'vertical';

          if (pointerAxis === 'horizontal') {
            gallery.classList.add('is-bys-dragging');
            if (gallery.setPointerCapture) gallery.setPointerCapture(event.pointerId);
          }
        }

        if (pointerAxis !== 'horizontal') return;

        event.preventDefault();
        gallery.scrollLeft = pointerStartScroll - distanceX;
      });

      function stopPointerDrag(event) {
        if (!pointerDragging) return;

        var wasHorizontal = pointerAxis === 'horizontal';
        var distanceX = event.clientX - pointerStartX;

        pointerDragging = false;
        pointerAxis = null;
        gallery.classList.remove('is-bys-dragging');

        if (gallery.releasePointerCapture && gallery.hasPointerCapture && gallery.hasPointerCapture(event.pointerId)) {
          gallery.releasePointerCapture(event.pointerId);
        }

        if (!wasHorizontal) return;

        suppressGalleryClick = Math.abs(distanceX) > 8;

        if (Math.abs(distanceX) > 28) {
          setActive(pointerStartIndex + (distanceX < 0 ? 1 : -1), 'smooth', true);
          return;
        }

        var closestIndex = 0;
        var closestDistance = Infinity;
        slides.forEach(function (slide, index) {
          var distance = Math.abs(slidePosition(slide) - gallery.scrollLeft);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });
        setActive(closestIndex, 'smooth', true);
      }

      gallery.addEventListener('pointerup', stopPointerDrag);
      gallery.addEventListener('pointercancel', stopPointerDrag);
      gallery.addEventListener('lostpointercapture', function () {
        pointerDragging = false;
        pointerAxis = null;
        gallery.classList.remove('is-bys-dragging');
      });

      gallery.addEventListener('click', function (event) {
        if (!suppressGalleryClick) return;
        event.preventDefault();
        event.stopPropagation();
        suppressGalleryClick = false;
      }, true);

      var galleryControls = content.querySelector('.shopify-section.main-product .swiper-buttons');

      /* Keep desktop navigation fixed to the gallery viewport, not inside the scrolling track. */
      if (galleryControls && gallery.parentElement) {
        var galleryShell = document.createElement('div');
        galleryShell.className = 'bys-drawer-gallery-shell';
        gallery.parentElement.insertBefore(galleryShell, gallery);
        galleryShell.appendChild(gallery);
        galleryShell.appendChild(galleryControls);
      }

      var previousButton = galleryControls ? galleryControls.querySelector('.swiper-button-prev') : null;
      var nextButton = galleryControls ? galleryControls.querySelector('.swiper-button-next') : null;

      if (previousButton) {
        previousButton.setAttribute('role', 'button');
        previousButton.setAttribute('tabindex', '0');
        previousButton.setAttribute('aria-label', 'Previous product image');
        previousButton.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          setActive(activeIndex - 1, 'smooth', true);
        });
      }

      if (nextButton) {
        nextButton.setAttribute('role', 'button');
        nextButton.setAttribute('tabindex', '0');
        nextButton.setAttribute('aria-label', 'Next product image');
        nextButton.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          setActive(activeIndex + 1, 'smooth', true);
        });
      }

      setActive(0, 'auto', false);
    }


      initDrawerGallery();
    }

    async addThemeProduct(form, button) {
      if (this.sheviAdding || !button || button.disabled) return;
      this.sheviAdding = true;
      const label = button.innerHTML;
      button.disabled = true;
      button.textContent = 'Adding…';
      let errorBox = form.querySelector('.shevi-add-error');
      if (errorBox) errorBox.remove();
      try {
        const cart = document.querySelector('cart-drawer');
        const sections = cart ? cart.getSectionsToRender().map(item => item.section) : [];
        const data = new FormData(form);
        data.set('sections', sections.join(','));
        data.set('sections_url', window.location.pathname);
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {method:'POST', body:data, headers:{'Accept':'application/json'}});
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || 'Unable to add this item. Please try again.');
        this.close();
        if (cart) cart.renderContents(result);
        if (typeof updateCartCounters === 'function') updateCartCounters();
        if (typeof updateFreeShipping === 'function') updateFreeShipping();
      } catch (error) {
        errorBox = form.ownerDocument.createElement('p');
        errorBox.className = 'shevi-add-error';
        errorBox.setAttribute('role','alert');
        errorBox.textContent = error.message;
        form.append(errorBox);
      } finally {
        this.sheviAdding = false;
        button.disabled = false;
        button.innerHTML = label;
      }
    }

    setActiveMedia(id) {
      const mediaFound = Array.from(this.querySelectorAll('[data-media-id]')).find(media => Number(media.dataset.mediaId) === id);
      if (mediaFound) {
        this.sliderInstance.slideTo(Number(mediaFound.dataset.index));
      }
    }

    /** Drawer coreß functions */
    toggle() {
      if (!this.toggleState) {
        this.open();
      } else {
        this.close();
      }
    }

    open() {
      this.toggleState = true;
      document.querySelector('body').classList.add('overflow-hidden');
      const quickCartDrawer = document.querySelector('.quick-cart-drawer__blocks');
      const closeButton = quickCartDrawer.querySelector('.button--close');
      quickCartDrawer.setAttribute('tabindex', '0');
      closeButton.setAttribute('tabindex', '0');
      this.classList.add('is--open');
      this.opened();

      const firstFocusableElement = this.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      if (firstFocusableElement) {
        firstFocusableElement.focus();
      }
    }

    close(event) {
      if (this.classList.contains('shevi-theme-product') && event) event.stopPropagation();
      this.toggleState = false;

      const shopTheLookDrawer = document.querySelector('shop-the-look-drawer');

      if (shopTheLookDrawer && !shopTheLookDrawer.classList.contains('is--open')) {
        document.querySelector('body').classList.remove('overflow-hidden');
      }
      if (!shopTheLookDrawer) {
        document.querySelector('body').classList.remove('overflow-hidden');
      }
      this.classList.remove('is--open');
      this.closed();
      this.toggleAriaExpanded();

      /** start autoplay on quick cart drawe close */
      if (document.querySelector('card-product-slider.product--open-on-quick-cart')) {
        document.querySelector('card-product-slider.product--open-on-quick-cart').slider.autoplay.start();
        document.querySelector('card-product-slider.product--open-on-quick-cart').classList.remove('product--open-on-quick-cart');
      }
    }

    toggleAriaExpanded(event) {
      if (event) {
        if (event.target.closest('button')) event.target.closest('button').setAttribute('aria-expanded', true);
        this.querySelector('.button--close').setAttribute('aria-expanded', true);
      } else {
        document.querySelectorAll('[aria-controls="quick-cart-drawer"]').forEach(button => {
          button.setAttribute('aria-expanded', false);
        });
      }
    }

    opened() {
      const openedEvent = new Event('opened', { bubbles: true });
      this.dispatchEvent(openedEvent);
    }

    closed() {
      const closedEvent = new Event('closed', { bubbles: true });
      this.dispatchEvent(closedEvent);
    }
  }

  customElements.define('quick-cart-drawer', QuickCartDrawer);
}
